// src/translations/de.ts
import { registerTranslation } from "@shoelace-style/localize";
var translation = {
  $code: "de",
  $name: "Deutsch",
  $dir: "ltr",
  autoplay: "Autoplay",
  audioPlayer: "Audio-Player",
  carousel: "Karussell",
  clearEntry: "Eingabe l\xF6schen",
  close: "Schlie\xDFen",
  comboboxDefaultPlaceholder: "Bitte suchen und ausw\xE4hlen",
  copy: "Kopieren",
  currentValue: "Aktueller Wert",
  goToSlide: (slide, count) => `Zu Folie ${slide} von ${count} gehen`,
  hidePassword: "Passwort verbergen",
  loading: "Wird geladen",
  mute: "Stummschalten",
  nextSlide: "N\xE4chste Folie",
  noResults: "Keine Ergebnisse gefunden",
  notifications: "Benachrichtigungen",
  numOptionsSelected: (num) => {
    if (num === 0) return "";
    return `Optionen ausgew\xE4hlt (${num})`;
  },
  openTranscript: "Transkript \xF6ffnen",
  optionGroup: "Optionsgruppe",
  pauseAudio: "Audio pausieren",
  playAudio: "Audio abspielen",
  playbackSpeed: "Wiedergabe Geschwindigkeit",
  playVideo: "Video abspielen",
  previousSlide: "Vorherige Folie",
  progress: "Fortschritt",
  remove: "Entfernen",
  removed: (name) => `${name} entfernt`,
  resize: "Gr\xF6\xDFe \xE4ndern",
  scrollToEnd: "Zum Ende scrollen",
  search: "Suchen",
  seekBar: "Schieberegler f\xFCr Suche",
  scrollToStart: "Zum Anfang scrollen",
  selectAColorFromTheScreen: "Farbe vom Bildschirm ausw\xE4hlen",
  selectDefaultPlaceholder: "Bitte ausw\xE4hlen",
  showLess: "Weniger anzeigen",
  showMore: "Mehr anzeigen",
  showPassword: "Passwort anzeigen",
  slideNum: (slide, count) => `Folie ${slide} von ${count}`,
  tagsSelected: "Optionen ausgew\xE4hlt",
  toggleColorFormat: "Farbformat umschalten",
  transcriptIsOpen: "Transkript ist offen",
  unmute: "Unmute"
};
registerTranslation(translation);
var de_default = translation;

export {
  de_default
};
